import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';
import { DEFAULT_IMAGES_PATH, COMPETENCY_TREE_GROUP } from '@/utils/constants';
import { generateColor } from '@/utils/utils';

@Component({
    name: 'tree-chart',
    components: {

    },
})

export default class TreeChart extends Vue {

    private get width() {
      return this.$el.clientWidth;
    }











    // ---------------------------------------------------------
    // Properties
    private margin: any = {
        top: 20,
        right: 120,
        bottom: 20,
        left: 120,
    };

    /**
     * Root node of the tree
     * @type {[type]}
     */
    private root: any = null;

    /**
     * Index value of each nodes
     * @type {Number}
     */
    private index: number = 0;

    /**
     * Tree node links animation duration.
     * @type {Number}
     */
    private duration: number = 0;

    /**
     * switch button enabled
     * @type {boolean}
     */
    private isZoomEnabled: boolean = false;

    /**
     * default Zooming view scale size
     * @type {float}
     */
    private zoomScale: number = 0.8;

    /**
     * dynamic Zooming  position maintain
     * @type {Number}
     */
    private svgPostion: number =  0;

    /**
     * default  taxonomy call height as equal to svg
     * @type {Number}
     */
    private taxonomyHeight: number = 450;

    @Prop()
    private data: any;

    @Prop()
    private isZoom!: boolean;

    private height() {
      return this.$el.clientHeight;
    }

    @Watch('data', {deep: true})
    private onChangeData(value: any) {
      this.renderTreeView(value);
    }

    @Watch('isZoom')
    private onChangeZoom(value: boolean) {
      const component = this;
      const isZoomEnabled = value;
      const treeElement: any = component.$el.getClientRects()[0];
      const svgElement: any = component.$el.querySelector('svg')!.getClientRects()[0];
      const svgHeight = component.$el.querySelector('svg')!.clientHeight / 2;
      const positionSvg = Math.abs(svgElement.top - treeElement.top + 100);
      const svg = d3.select(this.$el).select('svg');
      component.zoomScale = (component.getScaleLevel(svgHeight) as number);
      if (isZoomEnabled) {
        const scale = component.zoomScale;
        svg
          .attr('transform', `scale(${scale},${scale})`)
          .attr('transform-origin', `300 ${Math.round(positionSvg)}`);
        document.body.scrollIntoView({behavior: 'smooth', block: 'start'});
      } else {
        component.zoomScale =  0.9;
        const scale = component.zoomScale;
        svg.attr('transform', `scale(${scale},${scale})`);
        this.$el.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    }

    // -----------------------------------------------------------------
    // Hooks
    private mounted() {
        // this.renderTreeView(this.data);
    }


    // ------------------------------------------------------------------
    // Methods
    private renderTreeView(data: any) {
        const component = this;
        const height: any = this.height;
        const treeData = data;
        const root: any = d3.hierarchy(treeData, (d) => {
          return d.children;
        });
        root.x0 = height / 2;
        root.y0 = 0;
        /**
         * collapse the tree node
         */
        const collapse = (d: any) => {
          if (d.children) {
            d._children = d.children;
            d._children.forEach(collapse);
            d.children = null;
          }
        };
        root.children.forEach(collapse);
        this.root = root;
        this.update(root, 0);
        let children = root.children[0];
        let node = root.children[0];
        const activeNode = root.children.find((item: any) => item.data && item.data.default);
        if (activeNode) {
           children = activeNode;
           node = activeNode;
        }
        component.$emit('onClickNode', node, component);
        if (!node.children) {
          this.appendLoader(children.data.id);
        }
      }
      private update(source: any, depth: any) {
        const component = this;
        const duration = this.duration;
        const width = this.width;
        const margin = this.margin;
        const root = this.root;

        // compute the new height
        const levelWidth = [1];
        const childCount = (level: any, n: any) => {
          if (n.children && n.children.length > 0) {
            if (levelWidth.length <= level + 1) {
              levelWidth.push(0);
            }
            levelWidth[level + 1] += n.children.length;
            n.children.forEach((d: any) => {
              childCount(level + 1, d);
            });
          }
        };
        childCount(0, root);
        const newHeight =
          (d3.max(levelWidth) as number) * (component.normalizeHeightBasedOnDepth(depth) as number);
        const treemap = d3.tree().size([newHeight, width]);

        const treeData = treemap(this.root);
        const nodes = treeData.descendants();
        const links = treeData.descendants().slice(1);

        d3.select(this.$el).select('svg').remove();
        const svg = d3.select(this.$el).append('svg');
        let positionSvg = 0;
        const scale = this.zoomScale;
        const rootNode = svg
          .attr('width', width + margin.right + margin.left)
          .attr('height', newHeight + margin.top + margin.bottom)
          .attr('transform', `scale(${scale},${scale})`)
          .append('g');
          // .attr('transform', `translate(${margin.left},${margin.top})`);

        if (this.isZoomEnabled) {
          const svgElement = (d3.select(this.$el).select('.taxonomy-tree-view  svg') as any).getBBox();
          const treeElement = (d3.select(this.$el).select('.taxonomy-tree-view') as any).getBBox();
          positionSvg = Math.abs(treeElement.top - svgElement.top);
          let svgHeight = d3.select(this.$el).select('.taxonomy-tree-view svg').attr('height') as any / 2;
          svgHeight = Math.round(svgHeight);
          positionSvg = positionSvg <= 70 ? positionSvg : 70;
          this.zoomScale = this.getScaleLevel(svgHeight) as number;
          let zscale = this.zoomScale;
          zscale = zscale ? zscale : 0.1;
          svg.attr('transform-origin', `300 ${positionSvg}`);
          svg.attr('transform', `scale(${zscale},${zscale})`);
        }

        nodes.forEach((d) => {
          d.y = d.depth * component.normalizeYPositionBasedOnDepth(d.depth);
        });

        const node = rootNode.selectAll('g.node').data(nodes, (d: any) => {
        component.index += component.index;
        return d.id || (d.id = component.index);
        });

        /**
         * Click handling on when each node get choosed
         */
        const click = (d: any) => {
          if (d.depth > 1 && d.data.hasChild) {
            component.appendLoader(d.data.id);
            if (d.children) {
              d._children = d.children;
              d.children = null;
              component.update(d, d.depth);
            } else {
              component.$emit('onClickNode', d, component);
            }
          } else if (d.depth === 1 && d.data.hasChild && !d.children) {
            const rootComp = component.root;
            const children = rootComp.children;
            for (let index = 0; index < children.length; index++) {
              const nodeChildren = children[index];
              if (nodeChildren.children) {
                nodeChildren._children = nodeChildren.children;
                nodeChildren.children = null;
              }
              children[index] = nodeChildren;
            }
            component.appendLoader(d.data.id);
            if (d.children) {
              d._children = d.children;
              d.children = null;
              component.update(d, d.depth);
            } else {
              component.$emit('onClickNode', d, component);
            }
          }
        };

        /**
         * Event get triggered when more info button got clicked
         * @param  {Node} d selected node
         */
        const onMoreInfoClick = (d: any) => {
          component.$emit('onClickNodeMoreInfo', d);
          d3.event.stopPropagation();
          component.updateMoreInfoActiveNodes(d.data.id);
        };

        const nodeEnter: any = node
          .enter()
          .append('g')
          .attr('class', (d: any) => {
            // Demo purpose for cap library
            return `node ${d.data.isDisabled ? 'disabled-events' : ''}`;
          })
          .on('click', click);

        const nodeText = nodeEnter
          .append('svg:foreignObject')
          .attr('text-anchor', (d: any) => {
            return d.children || d._children ? 'end' : 'start';
          })
          .style('fill-opacity', 1e-6)
          .attr('width', 250)
          .attr('height', 38)
          .append('xhtml:div')
          .style('border', (d: any) => {
            if (d.depth === 1) {
              const colorCode = COMPETENCY_TREE_GROUP[d.data.id]
                ? COMPETENCY_TREE_GROUP[d.data.id].color
                : '#000';
              return `2px solid ${ colorCode }`;
            }

          })
          .attr('class', (d: any) => {
            const hasChildClass = d.data.hasChild ? '' : ' node-no-child';
            const id = ` node-label-${d.data.id.replace(/\./g, 's')}`;
            return `${'node-label node-'}${d.depth}${hasChildClass}${id}`;
          });

        // Node label
        nodeText
          .append('xhtml:div')
          .attr('class', 'node-text')
          .attr('title', (d: any) => {
            return d.data.name;
          })
          .text((d: any) => {
            return component.truncateString(d.data.name);
          });

        nodeText
          .append('xhtml:div')
            .attr('class', 'node-more-info')
            .append('i')
            .attr('class', 'ic_info_outline material-icons')
            .text('ic_info_outline')
            .on('click', onMoreInfoClick);

        const nodeUpdate = nodeEnter.merge(node);

        nodeUpdate
          .transition()
          .duration(duration)
          .attr('transform', (d: any) =>  {
            const sourceY =
              d.y + component.normalizeYPositionBasedOnDepth(d.depth - 1);
            const sourceX = d.x - 20;
            return `translate(${sourceY},${sourceX})`;
          });

        node
          .exit()
          .transition()
          .duration(duration)
          .attr('transform', (d: any) => {
            const sourceY =
              source.y + component.normalizeYPositionBasedOnDepth(d.depth);
            const sourceX = d.x - 20;
            return `translate(${sourceY},${sourceX})`;
          })
          .remove();

        const link = rootNode.selectAll('path.link').data(links, (d: any) => {
          return d.id;
        });
        /**
         * Generates the diagonal path
         */
        const diagonal = (s: any, d: any) => {
          const sourceX = s.x;
          const sourceY = s.y + component.normalizeYPositionBasedOnDepth(d.depth);
          const selectedNodeX = d.x;
          const selectedNodeY =
            d.y +
            component.normalizeYPositionBasedOnDepth(d.depth) +
            component.normalizePathPositionBasedOnDepth(d.depth);
          const path = `M ${sourceY > 0 ? sourceY : 0} ${sourceX > 0 ? sourceX : 0}
                  C ${((sourceY > 0 ? sourceY : 0) + (selectedNodeY > 0 ? selectedNodeY : 0)) / 2} ${sourceX > 0 ? sourceX : 0},
                    ${((sourceY > 0 ? sourceY : 0) + (selectedNodeY > 0 ? selectedNodeY : 0)) / 2} ${selectedNodeX > 0 ? selectedNodeX : 0},
                    ${selectedNodeY > 0 ? selectedNodeY : 0} ${selectedNodeX > 0 ? selectedNodeX : 0}`;

          return path;
        };

        const linkEnter: any = link
          .enter()
          .insert('path', 'g')
          .attr('class', (d: any) => {
            const id = d.data.id.replace(/\./g, 's');
            return `${'link link-'}${id}${' link-'}${d.depth}`;
          })
          .attr('copyclass', (d: any) => {
            const id = d.data.id.replace(/\./g, 's');
            return `${'link link-'}${id}${' link-'}${d.depth}`;
          })
          .attr('d', () => {
            const o = {
              x: source.x0,
              y: source.y0,
            };
            return diagonal(o, o);
          });

        const linkUpdate = linkEnter.merge(link);

        linkUpdate
          .transition()
          .duration(duration)
          .attr('d', (d: any) => {
            return diagonal(d, d.parent);
          });

        link
          .exit()
          .transition()
          .duration(duration)
          .attr('d', () => {
            const o = {
              x: source.x,
              y: source.y,
            };
            return diagonal(o, o);
          })
          .remove();

        nodes.forEach((d: any) => {
          d.x0 = d.x;
          d.y0 = d.y;
        });
        if (depth === 1) {
            d3.select(this.$el).select('.node-1').classed('disable-events', false);
            d3.select(this.$el).select(`.node-label-${source.data.id}`).classed('disable-events', true);
        }

        const newLevelWidth =
          component.getWidthByTreeDepth() + margin.right + margin.left;
        svg.attr('width', newLevelWidth);
        this.$emit('chartUpdated');
      }
      private updateData(selectedNode: any, newNodes: any) {
        const component = this;
        let childArray: any;
        if (!selectedNode.children) {
           childArray = [];
        }

        selectedNode.height = selectedNode.height + 1;

        newNodes.forEach((d: any) => {
          const obj: any = d3.hierarchy(d);
          obj.data.parent = selectedNode.name;
          obj.depth = selectedNode.depth + 1;
          obj.parent = selectedNode;
          obj.name = d.name;
          childArray.push(obj);
        });
        selectedNode.children = childArray;

        component.update(selectedNode, selectedNode.depth);
      }
      private normalizeHeightBasedOnDepth(depth: any) {
        if (depth === 0 || depth === 1) {
          return 70;
        } else if (depth === 2) {
          return 75;
        } else if (depth === 3 || depth === 4) {
          return 80;
        } else if (depth === 5) {
          return 85;
        } else if (depth === 6) {
          return 90;
        } else if (depth === 7) {
          return 95;
        }
      }
      private normalizeYPositionBasedOnDepth(depth: any) {
        if (depth >= 0) {
          if (depth === 1) {
            return 110;
          } else if (depth === 2) {
            return 130;
          } else if (depth === 3) {
            return 160;
          } else if (depth === 4) {
            return 175;
          } else if (depth === 5) {
            return 200;
          } else if (depth === 6) {
            return 210;
          } else if (depth === 7) {
            return 238;
          }
        }
        return 0;
      }
      private normalizePathPositionBasedOnDepth(depth: any) {
        if (depth >= 0) {
          if (depth === 0) {
            return 0;
          } else if (depth === 1) {
            return 65;
          } else if (depth === 2) {
            return 155;
          } else if (depth === 3) {
            return 145;
          } else if (depth === 4) {
            return 230;
          } else if (depth === 5) {
            return 220;
          } else if (depth === 6) {
            return 240;
          } else if (depth === 7) {
            return 255;
          }
        }
        return 0;
      }
      private updateMoreInfoActiveNodes(id: any) {
        const component = this;
        id = id.replace(/\./g, 's');
        d3.select(this.$el).selectAll('svg g path.link').each((index: any, element: any) => {
          const replaceClass = d3.select(this.$el).select(element).attr('copyclass');
          d3.select(element).attr('class', replaceClass);
        });
        d3.select(this.$el).select('.node-label').classed('selected', false);
        d3.select(this.$el).select(`.node-label-${id}`).classed('selected', true);
        const ids = id.split('-');
        for (let index = 0; index < ids.length; index++) {
          let newId = '';
          for (let nextIndex = 0; nextIndex <= index; nextIndex++) {
            if (nextIndex > 0) {
              newId = `${newId}-${ids[nextIndex]}`;
            } else {
              newId = newId + ids[nextIndex];
            }
          }
          d3.select(this.$el).select(`svg g path.link-${newId}`)
            .attr('class', `selected link link-${newId}`);
        }
      }
      private truncateString(text: any) {
        if (text && text.length > 45) {
          return `${text.substring(0, 45)}...`;
        }
        return text;
      }
      private appendLoader(id: any) {
        const component = this;
        id = id.replace(/\./g, 's');
        d3.select(this.$el).select(`.node-label-${id} .node-more-info`).style('display', 'none');
        d3.select(this.$el).select(`.node-label-${id}`).append('div')
          .html(`<div class="loader"><img src="${DEFAULT_IMAGES_PATH.loader}"></div>`);
      }
      private getWidthByTreeDepth() {
        const component = this;
        let width = 800;
        const nodeLabel: any = document.querySelectorAll('.node-label');
        nodeLabel.forEach((node: any) => {
          if (nodeLabel) {
            if (node.classList.contains('node-7')) {
              width = 2000;
            } else if (node.classList.contains('node-6')) {
              width = 1600;
            } else if (node.classList.contains('node-5')) {
              width = 1350;
            } else if (node.classList.contains('node-4')) {
              width = 1200;
            }
          }
        });
        return width;
      }
      private getScaleLevel(svgHeight: any) {
        if (svgHeight < 500) {
          return 0.5;
        } else if (svgHeight < 1000) {
          return 0.2;
        } else if (svgHeight > 1000) {
          return 0.1;
        }
      }

}
